import Vue from 'vue'
import Row from '../grid/Row'
import Column from '../grid/Column'
Vue.component('row', Row)
Vue.component('column', Column)



// WEBPACK FOOTER //
// ./src/lib/global.js